import { useContext } from 'react';
import { OnStartWarningHook } from '../../../../_Common/Const/Rutiner';
import BOBehorighetsKontrollQuery from '../Queries/BOBehorighetsKontroll.gql';
import {
  BOBehorighetsKontroll,
  BOBehorighetsKontrollVariables,
} from '../Queries/_QueryTypes/BOBehorighetsKontroll';
import { useQuery } from '@apollo/client';
import { ActiveDatabaseContext } from '../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';

export const useStatistikrapporteringOnStartWarningHook: OnStartWarningHook =
  isLoggedIn => {
    const { activeDatabase } = useContext(ActiveDatabaseContext);
    const { data, loading } = useQuery<
      BOBehorighetsKontroll,
      BOBehorighetsKontrollVariables
    >(BOBehorighetsKontrollQuery, {
      variables: { dbname: activeDatabase ?? '' },
      skip: !activeDatabase || !isLoggedIn,
    });

    return {
      loading: loading,
      ok: !loading && Boolean(data?.rtn?.BOBehorighetsKontroll?.statusOK),
      warningText: data?.rtn?.BOBehorighetsKontroll?.meddelande ?? '',
    };
  };
